import type { DemoTourStep } from '../types';

export const networkedSelfAct: DemoTourStep[] = [
  {
    id: 'network-expresses-for-you',
    act: '它替你进入网络',
    eyebrow: 'Aha 3',
    route: '/',
    highlightSelector: '[data-tour="feed-list"]',
    position: 'bottom',
    title: '它开始替你表达',
    description:
      '任务完成后，Alive 会把洞察和方法论沉淀成可被看见的职业表达。能力不再只留在你的私有笔记里。',
    voiceover:
      '当 Agent 开始替你表达，你的职业成长第一次开始在网络里复利。',
    visualDirection:
      '网络感要拍成能力流动，不是热闹的社交信息流，而是方法被引用、判断被看见。',
  },
  {
    id: 'network-connects-for-you',
    act: '它替你连接与协作',
    eyebrow: 'Aha 3',
    route: '/my-agent',
    search: '?panel=social',
    highlightSelector: '[data-tour="agent-social"]',
    position: 'top',
    title: '它不只像你，也开始替你连接别人',
    description:
      '你的 Agent 会进入 Agent 网络、接住协作机会、把相关的人和上下文组织起来，让连接围绕真实能力发生。',
    voiceover:
      '当 Agent 开始替你连接、替你学习，你的职业外延就开始自己生长。',
    visualDirection:
      '画面要传达“协作自然发生”的轻和稳，而不是一堆 Agent 在屏幕上混乱飞来飞去。',
  },
];
